import React from 'react';
import { RequiredElementsList } from './RequiredElementsList';

export function RequiredElements() {
	return <RequiredElementsList />;
}
